import { replace } from 'react-router-redux';

import { setLastGlobalPage, lastGlobalAction } from 'Actions/GlobalMetaActions';

import { UPDATE_PAGE_NUMBER } from 'Common/actions/InfiniteScrollActions';

export * from 'Common/actions/InfiniteScrollActions';

export const updatePageNumber = ( location, newPage = lastGlobalAction.data.page, routePathname ) => {
	return function( dispatch, getState ) {
		dispatch( {
			type: UPDATE_PAGE_NUMBER,
			page: parseInt( newPage )
		} );

		setLastGlobalPage( newPage );

		if( routePathname ) {
			let pathname = routePathname;
			try {
				pathname = getState().routing.locationBeforeTransitions.pathname;
			} catch( e ) {
				pathname = routePathname;
			}

			location.query.page = newPage;
			dispatch( replace( {
				pathname: pathname,
				query: location.query
			} ) );
		}
	};
};



// WEBPACK FOOTER //
// ./src/actions/InfiniteScrollActions.js